var exports = {
  "z": "root__MTX8wX",
  "M": "fontSmoothing__W7vzT-",
};

module.exports = exports;
